import React from 'react'
import '../../styles/Forms.scss'
import {ServiceEnum} from '../../../model/ServiceEnum'
import {useCurrentGuildContext, useDatxPathGenerator} from '../../../../util/routing'
import {NewCompanyItemDescription} from '../description/NewCompanyItemDescription'
import {getCompanyItemsFromFile} from '../../readImportedFile'
import {useCreateDefaultServiceRequestMutation} from '../../rtkServiceRequestApi'
import {ROUTES} from '../../../../constants/routing'
import {ItemMatchingInputDTO, NewItemInputDTO} from '../../../model/NewItemInput'
import {array, mixed, object, string} from 'yup'
import {ServiceRequestFormTemplate} from '../../genericComponents/formTemplate/ServiceRequestFormTemplate'
import {ServiceRequestStep} from '../../model/ServiceRequestStep'
import {UploadTemplateItemCreation} from '../common/UploadTemplateItemCreation'
import {ReviewNewItemsForm} from '../newManufacturerItems/ReviewStep/ReviewNewItemsForm'
import {ServiceRequestWorkflowInput} from '../../model/ServiceRequestWorkflowInput'

export interface CustomerItemCreationForm extends ServiceRequestWorkflowInput {
    file: File | undefined
    items: NewItemInputDTO[] | ItemMatchingInputDTO[]
}

const itemSchema = {
    file: mixed().required(),
    items: array().required().min(1)
}

const validationSchema = {
    ...itemSchema,
    selectedWorkflowId: string().required()
}

export const NewCompanyItemsForm = () => {
    const generatePath = useDatxPathGenerator()
    const [currentGuildContext] = useCurrentGuildContext()
    const [createRequest, {isLoading}] = useCreateDefaultServiceRequestMutation()

    function handleCompleteUploadForm(itemCreation: CustomerItemCreationForm): Promise<any> | undefined {
        if (!itemCreation.file) return
        if (!itemCreation.items) return
        if (!itemCreation.selectedWorkflowId) return

        return createRequest({
            service: ServiceEnum.NEW_COMPANY_ITEMS,
            guildId: currentGuildContext?.guildId ?? '',
            file: itemCreation.file,
            items: itemCreation.items as NewItemInputDTO[],
            workflowConfigurationId: itemCreation.selectedWorkflowId
        })
    }

    async function handleFileUpload(tempFile: File) {
        return await getCompanyItemsFromFile(tempFile)
    }

    const steps: ServiceRequestStep[] = [
        {
            name: 'Create Company Items',
            component: <UploadTemplateItemCreation description={NewCompanyItemDescription}
                                                   handleFileUpload={handleFileUpload} />,
            pageValidation: object<CustomerItemCreationForm>(itemSchema)
        }, {
            name: 'Create Company Items',
            component: <ReviewNewItemsForm serviceType={ServiceEnum.NEW_COMPANY_ITEMS} />,
            pageValidation: object<CustomerItemCreationForm>(validationSchema)
        }
    ]

    return <ServiceRequestFormTemplate
        steps={steps}
        handleFormSubmit={handleCompleteUploadForm}
        initialValues={{
            file: undefined,
            items: [],
            selectedWorkflowId: ''
        }}
        title="Create Company Items"
        previousUrl={generatePath(ROUTES.newPartsServiceForm.path)}
    ></ServiceRequestFormTemplate>

}
